import styles from "./PartnerSliderComp.module.css";

const partners = [
  // {
  //   name: "24-7 Consultant",
  //   image: "/partners/24-7-consultant.webp",
  // },
  {
    name: "First Choice Medical Care",
    image: "/partners/first-choice-medical-care.webp",
  },
  {
    name: "Medical Imaging Technology",
    image: "/partners/medical-imaging-technology.webp",
  },
  {
    name: "First Choice Medical Care",
    image: "/partners/first-choice-medical-care.webp",
  },
];

export default function PartnerSliderComp() {
  const sliderItems = [...partners, ...partners, ...partners];

  return (
    <section className={styles.section} aria-label="Partner logos">
      <div className={styles.sliderViewport}>
        <div className={styles.sliderTrack}>
          {sliderItems.map((partner, index) => (
            <article
              key={`${partner.name}-${index}`}
              className={styles.logoCard}
              aria-label={partner.name}
            >
              <img
                src={partner.image}
                alt={partner.name}
                className={styles.logoImage}
                loading="lazy"
              />
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
